import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const FlagIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M3.33337 12.5C3.33337 12.5 4.16671 11.6667 6.66671 11.6667C9.16671 11.6667 10.8334 13.3333 13.3334 13.3333C15.8334 13.3333 16.6667 12.5 16.6667 12.5V2.49999C16.6667 2.49999 15.8334 3.33332 13.3334 3.33332C10.8334 3.33332 9.16671 1.66666 6.66671 1.66666C4.16671 1.66666 3.33337 2.49999 3.33337 2.49999V12.5Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.33337 18.3333V12.5"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
